(function () {
  const originalImages = new WeakMap();

  function getSwatch(target) {
    return target.closest?.(
      '.tfh-linked-color-swatch[data-linked-image]'
    );
  }

  function getProductImage(productCard) {
    const wrapper =
      productCard.querySelector(
        '.js-product-card-images-wrapper.is-active'
      ) ||
      productCard.querySelector(
        '.product-card__image-wrapper.is-active'
      ) ||
      productCard.querySelector(
        '.js-product-card-images-wrapper'
      ) ||
      productCard.querySelector(
        '.product-card__image-wrapper'
      );

    if (!wrapper) return null;

    return wrapper.querySelector(
      'img.product-card__image, img'
    );
  }

  function saveOriginalImage(productCard, img) {
    if (originalImages.has(productCard)) return;

    const picture = img.closest('picture');

    const sources = picture
      ? Array.from(picture.querySelectorAll('source')).map((source) => ({
          element: source,
          srcset: source.getAttribute('srcset'),
          sizes: source.getAttribute('sizes')
        }))
      : [];

    originalImages.set(productCard, {
      img: img,
      src: img.getAttribute('src'),
      srcset: img.getAttribute('srcset'),
      sizes: img.getAttribute('sizes'),
      sources: sources
    });
  }

  function showLinkedImage(swatch) {
    const imageUrl = swatch.dataset.linkedImage;
    if (!imageUrl) return;

    const productCard = swatch.closest('.js-product-card');
    if (!productCard) return;

    const img = getProductImage(productCard);
    if (!img) return;

    saveOriginalImage(productCard, img);

    const picture = img.closest('picture');

    if (picture) {
      picture.querySelectorAll('source').forEach((source) => {
        source.setAttribute('srcset', imageUrl);
      });
    }

    img.removeAttribute('sizes');
    img.setAttribute('srcset', imageUrl);
    img.setAttribute('src', imageUrl);
  }

  function restoreOriginalImage(swatch) {
    const productCard = swatch.closest('.js-product-card');
    if (!productCard) return;

    const original = originalImages.get(productCard);
    if (!original) return;

    const img = original.img;

    if (original.src !== null) {
      img.setAttribute('src', original.src);
    } else {
      img.removeAttribute('src');
    }

    if (original.srcset !== null) {
      img.setAttribute('srcset', original.srcset);
    } else {
      img.removeAttribute('srcset');
    }

    if (original.sizes !== null) {
      img.setAttribute('sizes', original.sizes);
    } else {
      img.removeAttribute('sizes');
    }

    original.sources.forEach((item) => {
      if (item.srcset !== null) {
        item.element.setAttribute('srcset', item.srcset);
      } else {
        item.element.removeAttribute('srcset');
      }

      if (item.sizes !== null) {
        item.element.setAttribute('sizes', item.sizes);
      } else {
        item.element.removeAttribute('sizes');
      }
    });

    originalImages.delete(productCard);
  }

  document.addEventListener('pointerover', function (event) {
    const swatch = getSwatch(event.target);
    if (!swatch) return;

    if (
      event.relatedTarget &&
      swatch.contains(event.relatedTarget)
    ) {
      return;
    }

    showLinkedImage(swatch);
  });

  document.addEventListener('pointerout', function (event) {
    const swatch = getSwatch(event.target);
    if (!swatch) return;

    if (
      event.relatedTarget &&
      swatch.contains(event.relatedTarget)
    ) {
      return;
    }

    restoreOriginalImage(swatch);
  });

  document.addEventListener('focusin', function (event) {
    const swatch = getSwatch(event.target);

    if (swatch) {
      showLinkedImage(swatch);
    }
  });

  document.addEventListener('focusout', function (event) {
    const swatch = getSwatch(event.target);

    if (swatch) {
      restoreOriginalImage(swatch);
    }
  });
})();